import { createContext, useContext, useState } from "react";

const DeviceContext = createContext(null);

export const DeviceProvider = ({ children }) => {
    const [device] = useState({
        serialKey: "UTW20260504001", // TODO: 실제 기기에서 받아올 값
        storeId: 5,
    });

    return (
        <DeviceContext.Provider value={{ device }}>
            {children}
        </DeviceContext.Provider>
    );
};

export const useDevice = () => useContext(DeviceContext);
